import { type UseQueryResult, useQuery } from 'react-query';
import {
  NoticeService,
  StaticStatusDropdownService,
} from '../../services/wealthlane-award-services';

const useGetGrantAcceptanceTemplateVariables = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Array<string> | undefined,
  unknown
> => {
  //   const { filter, sorting, skipCount, maxResultCount } = tableInfo;
  const grantAcceptanceTemplateVariables = useQuery(
    ['getGrantAcceptanceTemplateVariables'],
    async () => {
      return await handleRequest(
        StaticStatusDropdownService.getApiAwardApiAppStaticStatusDropdownGrantAgreementTemplateConstDropdown()
      );
    }
  );

  return grantAcceptanceTemplateVariables;
};

export default useGetGrantAcceptanceTemplateVariables;
